/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ active: NonNullable<unknown>, archived: NonNullable<unknown> }} Cargos_CountInputs */

const en_cargos_count = /** @type {(inputs: Cargos_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.active} active, ${i?.archived} archived/sold)`)
};

const es_cargos_count = /** @type {(inputs: Cargos_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.active} activas, ${i?.archived} archivadas/agotadas)`)
};

/**
* | output |
* | --- |
* | "({active} active, {archived} archived/sold)" |
*
* @param {Cargos_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_count = /** @type {((inputs: Cargos_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_count(inputs)
	return es_cargos_count(inputs)
});